import React, { Suspense, useEffect, useRef, useState } from "react";
import { useUI } from "../stores/useUI";
import { Leva } from "leva";
import { EcctrlJoystick } from "../../src/EcctrlJoystick";
import UI from "./UI";
import { Canvas, useLoader, useThree } from "@react-three/fiber";
import { Bvh, PerspectiveCamera, Preload } from "@react-three/drei";
import Game from "./Game";
import { useAuth } from "../stores/useAuth";
import { IsProduction } from "../utils/client";
import * as THREE from "three";

const SkyboxBackground = () => {
  const { scene } = useThree();
  const [texture] = useLoader(THREE.CubeTextureLoader, [[
    '/skyboxes/pink/right+x.png',
    '/skyboxes/pink/left-x.png',
    '/skyboxes/pink/top+y.png',
    '/skyboxes/pink/bottom-y.png',
    '/skyboxes/pink/back+z.png',
    '/skyboxes/pink/front-z.png',
  ]]);

  useEffect(() => {
    scene.background = texture;
    return () => { scene.background = null; };
  }, [texture, scene]);

  return null;
};

const EcctrlJoystickControls = () => {
  const [isTouchScreen, setIsTouchScreen] = useState<boolean>(false);
  
  useEffect(() => {
    // Check if using a touch control device, show/hide joystick
    if (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0)) {
      setIsTouchScreen(true);
    } else {
      setIsTouchScreen(false);
    }
  }, []);
  
  return (
    <>
      {isTouchScreen && <EcctrlJoystick buttonNumber={5} />}
    </>
  );
};

const RootComponent = () => {
  const currentMap = useUI((state) => state.currentMap);
  const initializeAuthService = useAuth((state) => state.initializeAuthService);
  const isInitializedAuthService = useRef(false);
  const [isWarmingUp, setIsWarmingUp] = useState(true);
  const [loaderWaitingWarmingUp, setLoaderWaitingWarmingUp] = useState<boolean>(true);

  useEffect(() => {
    if (!isInitializedAuthService.current) {
      initializeAuthService();
      isInitializedAuthService.current = true;
    }
  }, []);

  useEffect(() => {
    if (currentMap) {
      const warmingTimer = setTimeout(() => setIsWarmingUp(false), 3500);
      const loaderTimer = setTimeout(() => {
        setLoaderWaitingWarmingUp(false);
      }, 4000);
      return () => {clearTimeout(warmingTimer);
        clearTimeout(loaderTimer);
      };

    } else {
      setIsWarmingUp(true);
      setLoaderWaitingWarmingUp(true);
    }
  }, [currentMap]);

  return (
    <>
      <Leva collapsed hidden={IsProduction} />
      <EcctrlJoystickControls />
      <UI isWarmingUp={loaderWaitingWarmingUp} />
      {currentMap && <Canvas
        shadows
        camera={{
          fov: 65,
          near: 0.1,
          far: 50,
        }}
        // onPointerDown={(e) => {
        //   if (e.pointerType === 'mouse' && !dialog.isOpen) {
        //     (e.target as HTMLElement).requestPointerLock();
        //   }
        // }}
      >
        <Suspense fallback={null}>
        {isWarmingUp && (
              <PerspectiveCamera 
                makeDefault 
                position={[30, 30, 30]} // Віддаляємо, щоб бачити всю карту
                fov={90} 
                onUpdate={(self) => self.lookAt(0, 0, 0)}
              />
            )}
          <Bvh firstHitOnly>
            <Game isWarmingUp={isWarmingUp}/>
          </Bvh>
        </Suspense>
        <SkyboxBackground />
        {/* <fog attach="fog" args={['#cccccc', 25, 50]} /> */}
        <Preload all />
      </Canvas>}
    </>
  );
};

export default RootComponent;